import { TextField } from "@mui/material";
import ExternalLinkAnchor from "../../common/ExternalLinkAnchor";

export default function ReadOnlyProjectDescriptionAnchor({
  url,
}: {
  url: string | null;
}) {
  if (!url) {
    return (
      <TextField
        value="-"
        variant="standard"
        id="project-description-document"
        label="Project Description Document Link"
        size="small"
        fullWidth
        sx={{
          marginBottom: 2,
        }}
        InputProps={{
          readOnly: true,
          disableUnderline: true,
        }}
      />
    );
  }

  return (
    <ExternalLinkAnchor
      url={url}
      label="project description document"
      dataTestid="project-description-document-anchor"
    />
  );
}
